<ng-template #eventLogCellRendererTmpl let-record="record" let-column="column" let-showRequestFn="showRequestFn"
  let-tableComponent="tableComponent">
  <ng-container [ngSwitch]="column.template || column.name">
    <ng-container *ngSwitchCase="'level'">
      <td [ngSwitch]="record[column.name]"
        class="d-flex flex-column justify-content-center align-items-stretch p-0 m-0 text-center">
        <div class="flex-grow-1" *ngSwitchCase="'error'">
          <div class="alert-danger font-weight-bold h-100 d-flex align-items-center justify-content-center">
            {{ record[column.name] | titlecase }}
          </div>
        </div>
        <div class="flex-grow-1" *ngSwitchCase="'warning'">
          <div class="alert-warning font-weight-bold h-100 w-100 d-flex align-items-center justify-content-center">
            {{ record[column.name] | titlecase }}
          </div>
        </div>
        <div class="flex-grow-1" *ngSwitchCase="'info'">
          <div class="alert-info h-100 w-100 d-flex align-items-center justify-content-center">
            {{ record[column.name] | titlecase }}
          </div>
        </div>
        <div class="flex-grow-1" *ngSwitchCase="'debug'">
          <div class="alert-secondary h-100 w-100 d-flex align-items-center justify-content-center">
            {{ record[column.name] | titlecase }}
          </div>
        </div>
        <div class="flex-grow-1" *ngSwitchDefault>
          <div class="h-100 w-100 d-flex align-items-center justify-content-center">
            {{ record[column.name] | titlecase }}
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container *ngSwitchCase="'title'">
      <td [ngSwitch]="record[column.name]" class="m-0 p-0 text-center align-middle">
        <div class="p-1 bg-success text-white" *ngSwitchCase="'Server Started'">
            {{ record[column.name] | titlecase }}
        </div>
        <ng-container *ngSwitchDefault>
            {{ record[column.name] }}
        </ng-container>
      </td>
    </ng-container>
    <td *ngSwitchCase="'userType'">
      {{ record[column.name]|uppercase }}
    </td>
    <td *ngSwitchCase="'data'">
      <pre>{{ record[column.name]|json}}</pre>
    </td>
    <td fes-table-view-default-cell-renderer *ngSwitchDefault [column]="column" [record]="record"
      [tableComponent]="tableComponent"></td>
  </ng-container>
</ng-template>

<div>
<app-event-log-table #eventLogTable [cellRendererTmplRef]="eventLogCellRendererTmpl" [tabConfig]="tabConfig" [detailFn]="detailFn"
  [isActiveView]="tabConfig.active" [contextJson]="tabConfig.viewInfo.id"
  (contextJsonChange)="contextJsonChangeHandler($event, tabConfig)">
  <div class="mx-2 card px-1 d-flex flex-row text-secondary" *ngIf="clientStats">
    <span class="font-weight-bold text-info mr-2">
      {{clientStats.connectedClients}} active client(s).
    </span>
    <span class="font-weight-bold" role="button" [attr.title]="clientStats.connectedWebUsers|json">
    {{clientStats.connectedWebUsers?.length}} web
    </span>&nbsp;and&nbsp;
    <span class="font-weight-bold" role="button" [attr.title]="clientStats.connectedMobileUsers|json">
    {{clientStats.connectedMobileUsers?.length}} mobile
    </span>
    &nbsp;connected users.
  </div>
</app-event-log-table>
</div>